<template>
  <div class="form-group">
    <label :for="id">{{ label }}</label>
    <div class="d-flex align-items-center">
      <input
        :id="id"
        type="color"
        class="form-control"
        :value="value"
        :disabled="disabled"
        style="max-width: 68px; height: 32px; padding: 2px 4px; cursor: pointer"
        @input="$emit('input', $event.target.value)"
      >
      <span v-if="showHex" class="ml-3 text-muted">{{ value }}</span>
    </div>
    <div v-if="error" class="invalid-tooltip d-block">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FColor',
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    value: { type: String, default: '#000000' },
    disabled: { type: Boolean, default: false },
    error: { type: String, default: null },
    showHex: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/FColor.vue